export default function (_ref) {
  var store = _ref.store,
      redirect = _ref.redirect,
      req = _ref.req;

  if (process.server && !req) {
    return true;
  }

  if (store.getters.isAuth === null || store.getters.isAuth === false) {
    return redirect('/sign/in');
  }
  var checkPath = function checkPath(groups) {
    if (groups.indexOf(7) !== -1) {
      return redirect('/support');
    }
    if (groups.indexOf(3) !== -1) {
      return redirect('/panel');
    }
    if (groups.indexOf(2) !== -1) {
      return redirect('/admin');
    }
    if (groups.indexOf(1) !== -1) {
      return redirect('/admin');
    }
  };

  checkPath(store.getters.userGroups);
}


//////////////////
// WEBPACK FOOTER
// ./middleware/check-main.js
// module id = ./middleware/check-main.js
// module chunks = 152